<template>
    <div class="menu-page">
        <div class="menu-header">
            <img class="header-avatar" :src="orginizInfo.morglogo" v-if="orginizInfo.morglogo"/>
            <img class="header-avatar" src="../../../assets/img/avatar_member.jpg" v-else/>
            <div class="header-name">{{ userInfo.company }}</div>
            <div class="header-tag">{{userInfo.rank_name}}</div>
        </div>
        <div class="vip-time">到期时间:{{userInfo.end_time}}
            <router-link class="pay" to="/member/payment">立即续费</router-link>
        </div>
        <div class="menus">
            <div class="flex flex-direction" v-for="(item,index) in menus" :key="index">
                <router-link :to="item.page"
                        class="mune-item"
                        :class="{ active: navIndex[0]  == item.value}">
                    <i class="iconfont" :class="[{active: navIndex[0]  == item.value},item.icon]"></i>
                    <div class="title" :class="{ active: navIndex[0]  == item.value}">{{item.label}}</div>
                </router-link>
                <div class="flex flex-direction" v-if="navIndex[0]  == item.value">
                    <router-link :to="child.page" class="menu-child" :class="{ active: navIndex[1]  == child.value}"
                         v-for="(child,position) in item.childs" :key="position">
                        {{child.label}}
                    </router-link>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import {memberMenus} from '@/utils/const'
    import {zhDate} from '@/utils/utils'
    import {userInfo,getOrganizInfo} from '@/api/member'

    export default {
        name: "MenuMemberModular",
        data() {
            return {
                menus: memberMenus,
                userInfo: '',
                orginizInfo: '',
            };
        },
        props: {
            navIndex: {
            },
            menu: {
                type: Number,
                default: 0
            },
        },
        computed: {
            user() {
                return this.$store.state.user
            }
        },
        created() {
            this.init()
            this.getOrganizInfo()
        },
        methods: {
            async init() {
                let _data = await userInfo()
                if (_data.status === 200) {
                    _data.data.end_time = zhDate(_data.data.end_time * 1000)
                    this.userInfo = _data.data
                }
            },
            async getOrganizInfo() {
                let _data = await getOrganizInfo()
                if (_data.status === 200) {
                    this.orginizInfo = _data.data
                }

            },
        },
        watch: {},
    };
</script>

<style scoped lang="scss">
    .menu-page {
        display: flex;
        flex-direction: column;
        width: 170px;
        flex-shrink: 0;
        .menu-header {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background-color: #0a2240;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            padding: 26px;
            .header-avatar {
                width: 74px;
                height: 74px;
                border-radius: 74px;
            }

            .header-name {
                text-align: center;
                font-size: 14px;
                line-height: 18px;
                color: #ffffff;
                margin-top: 12px;
            }
            .header-tag {
                height: 25px;
                line-height: 25px;
                background-color: #0a2240;
                border-radius: 13px;
                border: solid 1px #ff9600;
                font-size: 12px;
                color: #ff9600;
                padding: 0 12px;
                margin-top: 20px;
            }

        }
        .vip-time {
            width: 100%;
            height: 32px;
            background-color: #0a2240dd;
            font-size: 10px;
            color: #ffffff;
            box-shadow: 0 6px 16px 1px rgba(10, 34, 64, 0.47);
            border-bottom-right-radius: 10px;
            border-bottom-left-radius: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            .pay {
                font-size: 12px;
                line-height: 15px;
                color: #ff9600;
                text-decoration: underline;
            }
        }
        .menus {
            width: 100%;
            flex: 1;
            background-color: #0a2240;
            box-shadow: 0 6px 16px 1px rgba(10, 34, 64, 0.47);
            border-radius: 10px;
            margin-top: 10px;

            .mune-item {
                height: 100px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                background: none;
                position: relative;

                &:after {
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    width: 100%;
                    height: 1px;
                    background: #ffffff33;
                    transform: translateY(-50%);
                    content: '';
                }
                &.active {
                    background: #233953;
                    border-radius: 10px;
                    &:before {
                        position: absolute;
                        right: -8px;
                        border-top: 8px solid transparent;
                        border-left: 8px solid #233953;
                        border-bottom: 8px solid transparent;
                        top: 50%;
                        transform: translateY(-50%);
                        content: '';
                    }
                }
                .title {
                    font-size: 18px;
                    color: #ffffff;
                    margin-top: 10px;
                    &.active {
                        color: #ff9600;

                    }
                }
                i {
                    font-size: 30px;
                    color: #ffffff;
                    &.active {
                        color: #ff9600;

                    }
                }
            }
            .menu-child{
                width: 100%;
                height: 58px;
                font-size: 18px;
                line-height: 58px;
                color: #ffffff;
                padding-left: 60px;
                background: #233953;
                border-bottom: 1px solid #ffffff33;
                &.active{
                    position: relative;
                    color: #ffa11a;
                    &:before {
                        position: absolute;
                        width: 3px;
                        height: 17px;
                        background-color: #ff9600;
                        border-radius: 2px;
                        left: 48px;
                        top: 50%;
                        transform: translateY(-50%);
                        content: '';
                    }
                }
            }
        }

    }
</style>
